/**
 * The one rule for whether a page may be indexed and its links followed.
 *
 * Kontent's "Exclude from Internal Indexing" and "No Follow" are optional
 * single-choice elements with no default, so a page may have "yes", "no" or
 * nothing. Only an explicit "yes" opts out; empty means indexable/followable.
 * Robots meta, XML and HTML sitemaps, hreflang and Algolia all use this.
 */

/** Codename of a Kontent multiple-choice element value, or '' when empty. */
const choiceCodename = (choice) => {
    if (typeof choice === 'string') return choice;
    const value = choice?.value;
    const first = Array.isArray(value) ? value[0] : value;
    return first?.codename || '';
};

const isOptedOut = (choice) => choiceCodename(choice) === 'yes';

/** Indexing policy for a Kontent master page item (or its elements). */
function getElementPolicy(elements) {
    return {
        indexable: !isOptedOut(elements?.exclude_from_internal_indexing),
        followable: !isOptedOut(elements?.no_follow),
    };
}

module.exports = { choiceCodename, isOptedOut, getElementPolicy };
